const pathname = window.location.pathname
const pathProForecastId = pathname.split('/').pop()

export default () => {
  let proForecastId;

  // use for dev
  if (pathname.indexOf('/pro-forecast-') > -1) {
    // proForecastId = 73
    proForecastId = 56
    // proForecastId = 'sample'
    // proForecastId = 'sample'
    // proForecastId = 2 // San Francisco (Multiple daily updates)
    // proForecastId = 94 // Texas
    // proForecastId = 59
  }

  if (pathname.indexOf('/proforecast/') > -1) {
    proForecastId = pathProForecastId
  }
  return {
    proForecastId
  }
}
